/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELResourceAttribute,
  OTELResourceAttribute$Outbound,
  OTELResourceAttribute$outboundSchema,
} from "./otelresourceattribute.js";

/**
 * OTEL resource information
 */
export type OTELResource = {
  /**
   * Resource attributes
   */
  attributes?: Array<OTELResourceAttribute> | undefined;
  /**
   * Number of dropped attributes
   */
  droppedAttributesCount?: number | undefined;
};

/** @internal */
export type OTELResource$Outbound = {
  attributes?: Array<OTELResourceAttribute$Outbound> | undefined;
  droppedAttributesCount?: number | undefined;
};

/** @internal */
export const OTELResource$outboundSchema: z.ZodMiniType<
  OTELResource$Outbound,
  OTELResource
> = z.object({
  attributes: z.optional(z.array(OTELResourceAttribute$outboundSchema)),
  droppedAttributesCount: z.optional(z.int()),
});

export function otelResourceToJSON(otelResource: OTELResource): string {
  return JSON.stringify(OTELResource$outboundSchema.parse(otelResource));
}
